export const accountTypeMap = {
  EMPLOYEE: '员工账号',
  STORE: '门店账号',
  OUTSOURCING: '外包账号',
  BRAND: '品牌账号',
  OVERSEAS_STORE: '海外门店',
  BRAND_LIKE: '品牌点赞',
  EXTERNAL: '外部账号'
}

export const userQueryEnumMap = {
  name: '用户名',
  email: '邮箱',
  phone: '手机号码',
  account: '账号名'
}
